// import mixpanel from 'mixpanel-browser';
// Raw MixPanel instance, to sort vuemixpanel restrictions
const mixpanel = require('mixpanel-browser');

mixpanel.init('aa733fb27fe0393bffa8f7be5bff1944');

export default mixpanel;
